<template>
  <div>
    <download-excel
      style="display: inline-block"
      :data="data1"
      :fields="json_fields"
      type="xls"
      name="代币套餐订单.xls"
      :fetch="startDownload"
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }">
        Excel导出
      </a-button>
    </download-excel>
    <a-table
      :columns="columns"
      :row-key="(record) => record.userUid"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="pic" slot-scope="text, record">
        <img :src="record" alt=""/>
      </template>
      <a-avatar slot="avatar" icon="user"/>
      <a-switch slot="memberStatus" default-checked @change="onChange"/>

      <template slot="operate" slot-scope="text, operate">
        <a
          href="javascript:;"
          @click="
            gotoDetails(
              `/home/tokenOrder/tokenOrderDetails?orderNo=${operate.orderNo}`,
              operate.orderNo
            )
          "
        >订单详情</a
        >

        <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input placeholder="Basic usage"/>
        </a-modal>
      </template>
    </a-table>
  </div>
</template>
<script>
import {packageListData, packageListDataSeach} from "@/api/packageApi.js";
import {querypackage} from "@/api/hometwoApi.js";
import { start } from "chromedriver";

const columns = [
  {
    title: "订单编号",
    dataIndex: "orderNo",
    sorter: true,
    align: "center",
    scopedSlots: {customRender: "orderNo"},
  },
  {
    title: "商品类型",
    dataIndex: "goodsPackage",
    align: "center",
    scopedSlots: {customRender: "goodsPackage"},
  },
  {
    title: "支付金额",
    dataIndex: "pricePay",
    align: "center",
    scopedSlots: {customRender: "pricePay"},
  },
  {
    title: "商品封面图片",
    dataIndex: "shopLogo",
    sorter: true,
    align: "center",
    scopedSlots: {customRender: "avatar"},
  },
  {
    title: "所属门店",
    dataIndex: "shopName",
    sorter: true,
    align: "center",
    scopedSlots: {customRender: "shopName"},
  },
  {
    title: "用户ID",
    dataIndex: "userUid",
    sorter: true,
    align: "center",
    scopedSlots: {customRender: "userUid"},
  },
  {
    title: "订单状态",
    dataIndex: "statusShopStr",
    sorter: true,
    width: "15%",
    align: "center",
    scopedSlots: {customRender: "statusShopStr"},
  },
  {
    title: "下单时间",
    dataIndex: "createTime",
    sorter: true,
    align: "center",
    scopedSlots: {customRender: "createTime"},
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    align: "center",
    scopedSlots: {customRender: "operate"},
  },
];

export default {
  props: ["formInline"],
  data() {
    return {
      data: [],
      data1: [],
      img: [],
      data1: [],
      json_fields: {
        订单编号: "orderNo",
        商品类型: "shopRunTypeStr",
        支付金额: "pricePay",
        商品封面: "avatar",
        所属门店: "shopName",
        用户ID: "userUid",
        订单状态: "statusShopStr",
        下单时间: "createTime",
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      limit: 10,
      page: 1,
    };
  },
  mounted() {
    // this.fetch();
    this.getPackageListData();
  },
  methods: {
    async startDownload(){
      // 构建查询参数，使用当前的筛选条件
       const userUid = this.formInline.userUid;
      const orderNo = this.formInline.orderNo;
      const shopId = this.formInline.shopId;
      const endDate = this.formInline.endDate;
      const startDate = this.formInline.startDate;
      
      // 第一步：获取总数量，判断数据规模
      const countRes = await packageListData(1, 1,654, userUid,orderNo, shopId,endDate, startDate);
      const totalCount = countRes.count || 0;
      
      if (totalCount === 0) {
        this.$message.warning('当前筛选条件下没有数据可导出');
        return [];
      }
      
      // 第二步：根据数据量决定获取策略
      let allData = [];
      
      if (totalCount <= 1000) {
        // 数据量较小，一次性获取
        const res = await packageListData(totalCount, 1, 654, userUid,orderNo, shopId,endDate, startDate);
        allData = res.data || [];
      } else {
        // 数据量较大，分页获取
        const pageSize = 100;
        const totalPages = Math.ceil(totalCount / pageSize);
        
        // 提示用户正在获取数据
        const loadingMsg = this.$message.loading(`正在获取数据... 0/${totalPages}页`, 0);
        
        try {
          for (let page = 1; page <= totalPages; page++) {
            const res = await packageListData(pageSize, page, 654, userUid,orderNo, shopId,endDate, startDate);
            if (res.data && res.data.length > 0) {
              allData = allData.concat(res.data);
            }
            // 更新进度提示
            loadingMsg();
            this.$message.loading(`正在获取数据... ${page}/${totalPages}页`, 0);
          }
        } finally {
          loadingMsg();
        }
      }
      
      this.$message.success(`成功获取 ${allData.length} 条数据，开始导出...`);
      return allData;
    },
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    aaa(row) {
      console.log(row);
    },
    hide() {
    },
    btn() {
      this.visible2 = true;
    },
    // 查询
    query() {
      console.log("e", this.formInline);
      this.loading = true;
      packageListDataSeach(
        this.limit,
        this.page,
        654,
        this.formInline.userUid,
        this.formInline.orderNo,
        this.formInline.shopId,
        this.formInline.endDate,
        this.formInline.startDate
      ).then((res) => {
        this.pagination.total = res.count;
        this.img = res.data.goodsRecord;
        this.data = res.data;
        let arr = [];
        res.data.forEach((item) => {
          arr.push(JSON.parse(item.goodsRecord));
        });
        this.loading = false;
        console.log(res);
      });
    },
    // 分页按钮数据
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      packageListData(
        this.limit,
        this.pagination.current,
        654,
        this.formInline.userUid,
        this.formInline.orderNo,
        this.formInline.shopId,
        this.formInline.endDate,
        this.formInline.startDate).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
        this.loading = false;
      });
    },
    getPackageListData() {
      this.loading = true;
      packageListData(
        this.limit,
        this.page,
        654,
        this.formInline.userUid,
        this.formInline.orderNo,
        this.formInline.shopId,
        this.formInline.endDate,
        this.formInline.startDate
      ).then((res) => {
        this.loading = false;
        this.pagination.total = res.count;
        this.img = res.data.goodsRecord;
        this.data = res.data;
        let arr = [];
        res.data.forEach((item) => {
          arr.push(JSON.parse(item.goodsRecord));
        });
      });
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    //详情
    gotoDetails(row) {
      console.log(row);
      this.$router.push(row);
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/tokenOrder/tokenOrderContent.vue